import { createContext } from "react";
import { ThemeConfig } from "@/constants/themes";


export const ThemeSelectorContext = createContext<ThemeConfig | null>(null);
